import {
  ApiRequest,
  ApiResponse,
  fetchDataFromAPITyped,
} from './api-requests';
import {
  DefaultPaymentMethodResponse,
  SetupIntentResponse,
} from '../models/payment-method-model';

/**
 * Wraps the SetupIntent / default-payment-method endpoints from the RFID
 * tap-to-charge contract (`§3.1 Default payment method`). These power the
 * "off-session" flow where the user authorizes a card once and the backend
 * later charges it when an RFID tap is authorized.
 */

export const createSetupIntent = async (): Promise<
  ApiResponse<SetupIntentResponse | null>
> => {
  const apiQuery: ApiRequest = {
    route: 'payments/setup-intent',
    request: { method: 'POST', entity: 'payments', body: {} },
  };
  return fetchDataFromAPITyped<SetupIntentResponse>(apiQuery);
};

export const getDefaultPaymentMethod = async (): Promise<
  ApiResponse<DefaultPaymentMethodResponse | null>
> => {
  const apiQuery: ApiRequest = {
    route: 'users/me/default-payment-method',
    request: { method: 'GET', entity: 'payments', body: undefined },
  };
  return fetchDataFromAPITyped<DefaultPaymentMethodResponse>(apiQuery);
};

export const setDefaultPaymentMethod = async (
  paymentMethodId: string,
): Promise<ApiResponse<DefaultPaymentMethodResponse | null>> => {
  const apiQuery: ApiRequest = {
    route: 'users/me/default-payment-method',
    request: {
      method: 'PUT',
      entity: 'payments',
      body: { payment_method_id: paymentMethodId },
    },
  };
  return fetchDataFromAPITyped<DefaultPaymentMethodResponse>(apiQuery);
};

export const removeDefaultPaymentMethod = async (): Promise<
  ApiResponse<DefaultPaymentMethodResponse | null>
> => {
  const apiQuery: ApiRequest = {
    route: 'users/me/default-payment-method',
    request: { method: 'DELETE', entity: 'payments', body: undefined },
  };
  return fetchDataFromAPITyped<DefaultPaymentMethodResponse>(apiQuery);
};
